export default "__VITE_ASSET__kmlOh46C__"